<script>
export default {
	mounted() {
		let filter_key =
				"filter_ID:" +
				this.$inertia.page.props.user?.id +
				this.$inertia.page.component,
			filter = JSON.parse(sessionStorage.getItem(filter_key));
		if (filter) {
			this.filter = filter;
			if (this.applyFilter) {
				this.applyFilter();
			}
		}
	},
	watch: {
		filter: {
			deep: true,
			handler() {
				let filter_key =
					"filter_ID:" +
					this.$inertia.page.props.user?.id +
					this.$inertia.page.component;
				sessionStorage.setItem(filter_key, JSON.stringify(this.filter));
			},
		},
	},
};
</script>
